
import React from 'react'
import WebViewScreen from '#app/components/WebViewScreen'
import { useAppSelector } from '../hooks'
import { selectCurrentCentralId } from '#app/central'
import { selectCentralToken } from '#app/api'
import { State } from '#app/types'

const NodeRedUI = () => {
  const centralId = useAppSelector(selectCurrentCentralId)
  const token = useAppSelector(selectCentralToken)
  const baseUrl = useAppSelector((state: State) => state.api.baseUrl)

  if (centralId == null || token == null) {
    return <></>
  }

  // New: Connect through cloud server tunnel instead of Traefik proxy
  // Pass authentication via query parameters (works with iframe/WebView)
  const uri = `${baseUrl}/nodered/api/ui?access_token=${token}&central_id=${centralId}`

  return <WebViewScreen uri={uri} />
}

export default NodeRedUI
